import { FC, ReactNode, useLayoutEffect, useRef, useState } from 'react'
import { BarraAcao, EspacoBarraAcao } from '../styles'

export interface BarraFixaProps {
  children: ReactNode
}

/**
 * OP-3619 — a barra fixa e o buraco que ela precisa deixar no fim da página.
 *
 * A altura não é constante: o motivo do bloqueio mora acima do botão e pode
 * ter três linhas ("faltam 3 itens por contar: A, B, C"). Com um espaçador
 * fixo de 84px a barra passava por cima do fim do conteúdo — justamente onde
 * costuma estar a última informação que a pessoa ia ler.
 *
 * Por isso a barra se mede a cada render e o espaçador copia a altura.
 */
export const BarraFixa: FC<BarraFixaProps> = ({ children }) => {
  const ref = useRef<HTMLDivElement>(null)
  const [altura, setAltura] = useState(84)

  useLayoutEffect(() => {
    const barra = ref.current
    if (!barra) return undefined
    const medir = () => setAltura((atual) => (Math.abs(barra.offsetHeight - atual) > 1 ? barra.offsetHeight : atual))
    medir()
    // O texto do impedimento muda com o estado da tela, não com o ciclo deste
    // componente: quem avisa da mudança de altura é o observer, não o render.
    if (typeof ResizeObserver === 'undefined') return undefined
    const observador = new ResizeObserver(medir)
    observador.observe(barra)
    return () => observador.disconnect()
  }, [])

  return (
    <>
      <EspacoBarraAcao $altura={altura} />
      <BarraAcao ref={ref} style={{ flexDirection: 'column', alignItems: 'stretch', gap: 8 }}>
        {children}
      </BarraAcao>
    </>
  )
}

export default BarraFixa
